import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ApproachStepItem } from '../../home.models';

@Component({
  selector: 'app-home-approach-section',
  standalone: true,
  templateUrl: './approach-section.component.html'
})
export class ApproachSectionComponent {
  @ViewChild('approachTimeline') approachTimeline!: ElementRef<HTMLElement>;

  @Input({ required: true }) approachSteps: ApproachStepItem[] = [];
}
